module.exports = __webpack_public_path__ + "static/media/sk.a06c456e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sk.png
// module id = 1980
// module chunks = 0